// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"96":"797a0aba","943":"3e0a2abe"}[chunkId] + ".chunk.js";
};